import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, toHandlers as _toHandlers, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "loan-details-wrapper" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  class: "loan-details-section",
  ref: "schoolConfirmationRef"
}
const _hoisted_4 = { class: "loan-details-section-header" }
const _hoisted_5 = { class: "loan-details-section-content" }
const _hoisted_6 = { class: "info-section" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "info-section" }
const _hoisted_9 = { class: "info" }
const _hoisted_10 = { class: "info-section" }
const _hoisted_11 = { class: "info" }
const _hoisted_12 = {
  class: "loan-details-section",
  ref: "loanTermsRef"
}
const _hoisted_13 = { class: "loan-details-section-header" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "loan-details-section-content" }
const _hoisted_16 = { class: "info-section" }
const _hoisted_17 = { class: "info" }
const _hoisted_18 = { class: "info-section" }
const _hoisted_19 = { class: "info" }
const _hoisted_20 = { class: "info-section" }
const _hoisted_21 = { class: "info" }
const _hoisted_22 = { class: "info-section" }
const _hoisted_23 = { class: "info" }
const _hoisted_24 = { class: "info-section" }
const _hoisted_25 = { class: "info" }
const _hoisted_26 = { class: "info-section" }
const _hoisted_27 = { class: "info" }
const _hoisted_28 = {
  class: "tooltip-wrapper",
  style: {"height":"18px","z-index":"1"}
}
const _hoisted_29 = { class: "loan-details-modals" }

import { computed, ref, onMounted } from "vue";
import { useStore } from "vuex";
import Tile from "@/components/shared/Tile.vue";
import { ApplicationStatusTypeIds } from "@/config/constants";
import Loader from "@/components/shared/Loader.vue";
import { PelLoanConfigurationDetails } from "@/models/pel";
import { School } from "@/models/school";
import PelSchoolConfirmation from "@/components/pel-loan-configuration/PelSchoolConfirmation.vue";
import PelLoanConfigurationModal from "@/components/pel-loan-configuration/PelLoanConfigurationModal.vue";
import Error from "@/components/shared/Error.vue";
import ConfirmYourLoanDetailsModal from "@/components/pel-loan-configuration/ConfirmYourLoanDetailsModal.vue";
import TooltipComponent from "@/components/shared/TooltipComponent.vue";
import Icon from "@/components/shared/Icon.vue";
import useApplicationInfo from "@/composables/application-info/useApplicationInfo";

interface LoanDetails {
  academicTerms: string;
  graduationDate?: Date;
  graduationDateDisplay: string;
  requestedAmount?: number;
  requestedAmountDisplay: string;
  requestedAmountPerTerm?: number;
  requestedAmountPerTermDisplay: string;
  school?: School;
  schoolName: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ApplicationInfoPEL',
  setup(__props, { expose: __expose }) {

const store = useStore();

const currentlyActiveModal = computed(() => store.getters["applicationInfoModule/ModalComponent"]);

const loanConfigurationModule = computed(() => store.state.loanConfigurationModule);

// Reactive
const info = ref({} as LoanDetails);

const {
  appData,
  applicationStatusId,
  closeSchoolConfirmationModal,
  dataRetrievalError,
  details,
  editable,
  editLoanTermsDisabled,
  error,
  initialDraw,
  loan,
  loanSvcError,
  requestedAmount,
  requestedAmountPerTerm,
  schoolName,
  getApplicationDetails,
  gettingData,
  handleSchoolConfirmation,
  updatingApp,
} = useApplicationInfo();

const pelDetails = computed<PelLoanConfigurationDetails>(() => details.value);

const loanAmount = computed<string>(() => {
  return requestedAmount.value;
});

const loanAmountPerTerm = computed<string>(() => {
  return requestedAmountPerTerm.value;
});

const graduationDate = computed<string>(() => {
  return pelDetails.value.graduationDateDisplay;
});

const academicTerms = computed<string>(() => {
  return pelDetails.value.academicTerms;
});

const modalComponent = computed(() => {
  return getModalComponent();
});

const modalEventListeners = computed(() => {
  switch (modalComponent.value) {
    case PelSchoolConfirmation:
      return {
        complete: handleSchoolConfirmation,
        close: closeSchoolConfirmationModal,
      };
    case PelLoanConfigurationModal:
      return {
        configurationComplete: handleLoanConfigurationComplete,
        close: closeLoanConfigModal,
      };
    case ConfirmYourLoanDetailsModal:
      return {
        openLoanConfigurationModal: handleBorrowAmountModal,
        openSchoolConfirmationModal: openSchoolConfirmationModal,
      };
    default:
      return {};
  }
});

const modalProps = computed(() => {
  switch (modalComponent.value) {
    case PelSchoolConfirmation:
      return {
        term: academicTerms.value,
        loading: updatingApp.value,
      };

    default:
      return {};
  }
});
// Methods

function getModalComponent() {
  switch (currentlyActiveModal.value) {
    case "ConfirmYourLoanDetails":
      return ConfirmYourLoanDetailsModal;
    case "PelLoanConfigurationModal":
      return PelLoanConfigurationModal;
    case "PelSchoolConfirmationModal":
      return PelSchoolConfirmation;
    default:
      return;
  }
}

async function handleLoanConfigurationComplete() {
  await closeLoanConfigModal();
}

async function closeLoanConfigModal() {
  await getApplicationDetails();
  store.dispatch("applicationInfoModule/closeModal", "PelLoanConfigurationModal");
}

function openSchoolConfirmationModal() {
  store.dispatch("applicationInfoModule/openModal", "PelSchoolConfirmationModal");
}

function handleBorrowAmountModal() {
  if (!editLoanTermsDisabled.value) {
    store.dispatch("applicationInfoModule/openModal", "PelLoanConfigurationModal");
  } else {
    store.dispatch("modal/openModal", {
      title: "Alert",
      description: "School confirmation details must be completed prior to selecting Loan Terms.",
      allowBackgroundScroll: false,
    });
  }
}

onMounted(async () => {
  await getApplicationDetails();
});

__expose({
  appData,
  initialDraw,
  loan,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Tile, null, {
    default: _withCtx(() => [
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "header" }, [
        _createElementVNode("p", { class: "title" }, "Loan Details")
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        (_unref(gettingData))
          ? (_openBlock(), _createBlock(Loader, { key: 0 }))
          : _createCommentVNode("", true),
        ((_unref(loanSvcError) || _unref(dataRetrievalError)) && !_unref(gettingData))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(Error)
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _cache[0] || (_cache[0] = _createTextVNode(" School Confirmation ", -1)),
                  (_unref(editable) && _unref(applicationStatusId) !== _unref(ApplicationStatusTypeIds).EVALUATION)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "edit-loan-config-link",
                        href: "#/",
                        onClick: openSchoolConfirmationModal
                      }, "Edit"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "info-title" }, "School", -1)),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("p", null, _toDisplayString(_unref(schoolName)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[2] || (_cache[2] = _createElementVNode("p", { class: "info-title" }, "Graduation Date", -1)),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(graduationDate.value), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[3] || (_cache[3] = _createElementVNode("p", { class: "info-title" }, "Academic Term(s)", -1)),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(academicTerms.value), 1)
                  ])
                ])
              ], 512),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[4] || (_cache[4] = _createTextVNode(" Loan Terms ", -1)),
                  (_unref(editable) && _unref(applicationStatusId) !== _unref(ApplicationStatusTypeIds).EVALUATION)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "edit-loan-config-link",
                        href: "#/",
                        disabled: _unref(editLoanTermsDisabled),
                        onClick: handleBorrowAmountModal
                      }, "Edit", 8, _hoisted_14))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "info-title" }, "Loan Amount", -1)),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("p", null, _toDisplayString(loanAmount.value), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _cache[6] || (_cache[6] = _createElementVNode("p", { class: "info-title" }, "Loan Amount Per Academic Term", -1)),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(loanAmountPerTerm.value), 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _cache[7] || (_cache[7] = _createElementVNode("p", { class: "info-title" }, "Repayment Type", -1)),
                    _createElementVNode("div", _hoisted_21, _toDisplayString(pelDetails.value?.repaymentTypeDisplay), 1)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _cache[8] || (_cache[8] = _createElementVNode("p", { class: "info-title" }, "Rate Selection", -1)),
                    _createElementVNode("div", _hoisted_23, _toDisplayString(pelDetails.value?.rateSelectionDisplay), 1)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _cache[9] || (_cache[9] = _createElementVNode("p", { class: "info-title" }, "Estimated In-School Monthly Payments", -1)),
                    _createElementVNode("div", _hoisted_25, _toDisplayString(pelDetails.value.monthlyInSchoolPaymentsDisplay), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _cache[10] || (_cache[10] = _createElementVNode("p", { class: "info-title" }, "Estimated Post-Grad Monthly Payments", -1)),
                    _createElementVNode("div", _hoisted_27, _toDisplayString(pelDetails.value.monthlyPostGradPaymentsDisplay), 1)
                  ])
                ])
              ], 512),
              _createElementVNode("div", _hoisted_28, [
                _createVNode(TooltipComponent, { class: "xs-bottom-center" }, {
                  toggle: _withCtx(() => [
                    _createElementVNode("b", null, [
                      _createVNode(Icon, { icon: "info" }),
                      _cache[11] || (_cache[11] = _createTextVNode(" Payment Estimates", -1))
                    ])
                  ]),
                  default: _withCtx(() => [
                    _cache[12] || (_cache[12] = _createElementVNode("div", null, [
                      _createTextVNode(" Payment Estimates � See Your Approval Disclosure in your Legal Packet and your Final Disclosure after school certification is completed for more details. "),
                      _createElementVNode("b", null, [
                        _createElementVNode("i", null, " The amount shown for In-School Monthly Payments is an average over the in-school period. ")
                      ]),
                      _createTextVNode(" Actual payment amounts will vary based on the number of days in a month, the days between loan disbursements and any variable interest rate. ")
                    ], -1))
                  ]),
                  _: 1
                })
              ])
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_29, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(modalComponent.value), _mergeProps(_toHandlers(modalEventListeners.value), modalProps.value), null, 16))
      ])
    ]),
    _: 1
  }))
}
}

})